import {css} from "@emotion/css";
import {RouteHelper} from "../../route/RouteHelper";
import React, {useEffect, useState} from "react";
import {
    managerAccessLevelHeader,
    prepareManagerAccessLevelTableRow
} from "../../component/manangerDetail/ManagerAccessLevelTable";
import {ManagerAccessLevelDetail} from "../../component/managerAccessLevelDetail/ManagerAccessLevelDetail";
import {ManagerAccessLevelService} from "../../serverService/managerAccessLevelService/ManagerAccessLevelService";
import {ServerErrorHandler} from "../../service/errorHandler/ServerErrorHandler";
import {Helmet} from "react-helmet";
import {useNavigate} from "react-router-dom";
import {
    DialogSize, RaikoBaseCardContainer,
    RaikoBaseContainer, RaikoBreadcrumb, raikoBreadCrumbItemGenerator,
    RaikoDefaultDialogPage, RaikoGridOneColumn,
    showErrorMessage, RaikoTableTitleContainer, RaikoCustomTable
} from "@moeindal/base-raiko-panel-components";

export const ManagerAccessLevelList = () => {

    const size = 10

    let page = 0
    const [accessLevelSelectedItemId, setAccessLevelSelectedItemId] = useState(-1);

    const service = new ManagerAccessLevelService()

    const [tableLoading, setTableLoading] = useState(false);
    const [accessList, setAccessList] = useState([]);
    const [pageCount, setPageCount] = useState(0);
    const [totalItems, setTotalItems] = useState(0);

    const [isNeedRefreshList, setIsNeedRefreshList] = useState(false);


    useEffect(() => {
        if (service) {
            getDataFromServer()
        }
    }, [])

    function getDataFromServer() {
        setTableLoading(true)

        service.getAccessLevelList(page, size)
            .then(response => {
                setPageCount(response.totalPage)
                setTotalItems(response.numberOfItems)

                const _list = []
                response.data.map((item, index) => {
                    _list.push(
                        prepareManagerAccessLevelTableRow(
                            item.id,
                            page * size + index + 1,
                            item.title ? item.title : "نا مشخص",
                            item.name)
                    )
                })

                setAccessList(_list)

                setTableLoading(false)
            }).catch(reason => {
            setTableLoading(false)
            showErrorMessage(
                new ServerErrorHandler(reason).getMessage("خطا در دریافت اطلاعات")
            )
        })
    }

    function handleChangePagination(newPage) {
        page = newPage
        getDataFromServer()
    }

    function handleAddNewAccessLevel() {
        handleOpenAccessDialog();
    }

    const navigate = useNavigate()

    function handleShowAccessDetail(itemId) {
        // setAccessLevelSelectedItemId(itemId)
        // handleOpenAccessDialog();
        navigate(RouteHelper.ManagersAccessDetail.globalUrl.replace(":id", itemId))
    }

    const [accessLevelDialogOpenState, setAccessLevelDialogOpenState] = useState(false);

    function handleCloseAccessLevelDialog() {
        setAccessLevelSelectedItemId(-1)
        setAccessLevelDialogOpenState(false)
        if (isNeedRefreshList) {
            setIsNeedRefreshList(false)
            page = 0
            getDataFromServer()
        }
    }

    function handleOpenAccessDialog() {
        setAccessLevelDialogOpenState(true)
    }

    return (
        <>
            <Helmet>
                <title>{RouteHelper.ManagersAccess.name}</title>
            </Helmet>
            <RaikoDefaultDialogPage
                onClose={handleCloseAccessLevelDialog}
                open={accessLevelDialogOpenState}
                pageTitle={"افزودن دسترسی جدید"}
                dialogSize={DialogSize.WRAP_CONTENT}
            >
                <ManagerAccessLevelDetail
                    accessSelectedItemId={accessLevelSelectedItemId}
                    changeNeedRefresh={setIsNeedRefreshList}
                />
            </RaikoDefaultDialogPage>

            <RaikoBaseContainer>
                <RaikoGridOneColumn className={css`gap: 1.5rem`}>
                    <RaikoBreadcrumb
                        breadCrumbItems={[
                            raikoBreadCrumbItemGenerator(
                                "مدیریت",
                                ""
                            ),
                            raikoBreadCrumbItemGenerator(
                                RouteHelper.ManagersAccess.name,
                                ""
                            ),
                        ]}/>

                    <RaikoBaseCardContainer>
                        <RaikoGridOneColumn>

                            <RaikoTableTitleContainer
                                title={"سطح دسترسی"}
                                hasCreateNewItem
                                handleCreateNewItem={handleAddNewAccessLevel}
                                amount={totalItems}
                            />

                            <RaikoCustomTable
                                isLoading={tableLoading}
                                data={accessList}
                                header={managerAccessLevelHeader}
                                pageCount={pageCount}
                                handlePaginationChange={handleChangePagination}
                                rowClicked={handleShowAccessDetail}
                            />
                        </RaikoGridOneColumn>

                    </RaikoBaseCardContainer>
                </RaikoGridOneColumn>
            </RaikoBaseContainer>

        </>
    )
}

